import type { ITheme } from '../../../utils/theme';

export const getPhoneInputBorderColor = (
  hasError: boolean,
  isDisabled: boolean,
  theme: ITheme
) => {
  if (hasError) {
    return `0.5px solid ${theme.palette.error.main}`;
  }
  if (isDisabled) {
    return `0.5px solid ${theme.palette.neutral[70]}`;
  }
  return `0.5px solid ${theme.palette.neutral[90]}`;
};
